module.exports = __webpack_public_path__ + "static/img/图层 525.fda81c73.png";